import { motion } from 'framer-motion'
import styled from 'styled-components'

export const SelectedBar = styled(motion.div)`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin: 8px 0 12px;
`

export const SelectedText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 13px;
	line-height: 122%;
	letter-spacing: 0.01em;
	color: #484848;
	display: flex;
	align-items: center;
	gap: 30px;

	img {
		width: 20px;
		cursor: pointer;
	}
`

export const Chip = styled(motion.span)`
	display: inline-flex;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 300;
	font-size: 13px;
	line-height: 122%;
	letter-spacing: 0.01em;
	color: #383838;
	align-items: center;
	gap: 5px;

	border: 1px solid #01924f;
	padding: 5px;

	svg {
		cursor: pointer;
	}
`

export const FiltersWrap = styled.div`
	--pad: 17px;
	--accent: #01924f;
	--cb-size: 18px;

	display: grid;
	max-width: 370px;
	margin: 12px 0 20px;
	padding: var(--pad);
	border: 1px solid #e6e6e9;
	border-radius: 12px;
	background: #fbfbfd;
`

export const Title = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 500;
	font-size: 13px;
	line-height: 122%;
	letter-spacing: 0.01em;
	text-transform: uppercase;
	color: #484848;
	margin-bottom: 20px;

	backface-visibility: hidden;
	transform-style: preserve-3d;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;

	display: flex;
	align-items: center;
	justify-content: space-between;

	span {
		color: #01924f;
	}

	border-bottom: 1px solid #d9d9d9;

	svg {
		cursor: pointer;
	}
`

export const Fieldset = styled.fieldset`
	border: 0;
	padding: 0;
	margin: 0;
`
export const OptionsGrid = styled.div`
	display: flex;
	margin: 20px 0;
	flex-direction: column;
	gap: 20px;
`

export const OptionLabel = styled.label`
	display: flex;
	align-items: center;
	gap: 8px;

	span {
		font-family: 'e-Ukraine', sans-serif;
		font-weight: 300;
		font-size: 15px;
		line-height: 122%;
		letter-spacing: 0.01em;
		color: #383838;
	}
`

export const Actions = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	margin-top: 15px;
	padding: 0 10px;
`

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
	appearance: none;
	-webkit-appearance: none;
	inline-size: var(--cb-size);
	block-size: var(--cb-size);
	border: 1px solid #383838;
	background: #fff;
	display: inline-grid;
	place-content: center;
	cursor: pointer;

	&::after {
		content: '✓';
		color: var(--accent, #01924f);
		font-weight: 500;
		font-size: 24px;
		line-height: 1;
		transform: scale(0.6);
		opacity: 0;
		transition: transform 0.16s ease, opacity 0.16s ease;
		transform-origin: center;
	}

	&:checked::after {
		transform: scale(1);
		opacity: 1;
	}
`









